/*
 * @Author: Teemo Ding
 * @Date: 2022-04-17 10:32:31
 * @LastEditTime: 2022-07-13 15:50:50
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/Reports/ReportsDetail/ReportConfig/index.tsx
 */
import {
  Checkbox,
  Input,
  Label,
  RadioGroup,
  RadioItem,
  Select,
} from '@/src/components/Antd';
import { ICategory, IReportCurrencyType } from '@/src/types/common/report';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';
import {
  languageLabel,
  languageList,
} from '@/locale/IntlProvider/IntlProvider';

const nameDict1 = {
  [ICategory.Order]: 'Order',
  [ICategory.Payment]: 'Payment',
  [ICategory.Promotion]: 'Promotion',
  [ICategory.Parcel]: 'Parcel',
  [ICategory.Customer]: 'Customer',
  [ICategory.Inventory]: 'Inventory',
  [ICategory.GiftCard]: 'Gift Card & Store Credit',
  [ICategory.Page]: 'Page',
  [ICategory.OrderLineItemsReport]: 'Order Line Items',
  [ICategory.Product]: 'Product',
  [ICategory.SubscriptionBuy]: 'Subscription Buy',
};

const ReportConfig = ({ name, type, storeCurrencyCode, disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      containerClassName={css.sectionContainer}
      titleClassName={css.titleClassName}
      title={name}>
      <div className={css.reportItem}>
        <Form.Item
          name='name'
          label={
            <Label
              title={getI18n('reports.reportpagecommon.reportName')}
              textLength={100}
              nameKey='name'
            />
          }
          className={css.reportName}
          rules={[
            {
              required: true,
              message: getI18n('reports.reportConfig.reportname_required'),
            },
          ]}
          labelCol={{ span: 24 }}>
          <Input size='large' maxLength={100} disabled={disabled} />
        </Form.Item>
        <div className={css.reportCategory}>
          <Label title={getI18n('reports.reportConfig.report_category')} />
          <p className={css.type}>{nameDict1[type] || name}</p>
        </div>
      </div>
      {(type == ICategory.Order ||
        type == ICategory.Payment ||
        type == ICategory.Parcel ||
        type == ICategory.GiftCard ||
        type == ICategory.SubscriptionBuy ||
        type == ICategory.Customer ||
        type == ICategory.OrderLineItemsReport) && (
        <Form.Item
          name='maskPii'
          valuePropName='checked'
          className={css.reportName}>
          <Checkbox disabled={disabled}>
            {getI18n('reports.reportConfig.mask_desc')}
          </Checkbox>
        </Form.Item>
      )}
      {type !== ICategory.Page && type !== ICategory.Inventory && (
        <Form.Item
          name='reportCurrencyType'
          initialValue={IReportCurrencyType.ReportingCurrency}
          label={
            <Label
              title={getI18n('reports.reportConfig.report_presentation')}
            />
          }
          labelCol={{ span: 24 }}
          className={css.reportName}>
          <RadioGroup className={css.presentationCurrency} disabled={disabled}>
            <RadioItem value={IReportCurrencyType.ReportingCurrency}>
              {getI18n('reports.reportpagecommon.reportingCurrency')} (
              {storeCurrencyCode})
            </RadioItem>
            <span className={css.direction}>
              {getI18n('reports.reportpagecommon.reportingCurrencyExp')}
            </span>
            <RadioItem
              disabled={type == ICategory.Customer || type == ICategory.Product}
              value={IReportCurrencyType.TransactionNativeCurrency}>
              {getI18n('reports.reportpagecommon.transactionNativeCurrency')}
            </RadioItem>
            <span className={css.direction}>
              {getI18n('reports.reportpagecommon.transactionNativeCurrencyExp')}
            </span>
          </RadioGroup>
        </Form.Item>
      )}

      <Form.Item
        name='templateLang'
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 8 }}
        label={
          <Label
            title={getI18n('reports.reportpagecommon.reportTemplateLanguage')}
          />
        }>
        <Select
          optionsList={languageList.map((item) => ({
            value: item,
            label: languageLabel[item],
          }))}></Select>
      </Form.Item>
    </SectionWrapper>
  );
};

export default ReportConfig;
